module.exports = __webpack_public_path__ + "img/0x250632378e573c6be1ac2f97fcdf00515d0aa91b.5aaafdd5.png";